import React from "react"
import "./connexion.css"
import {checkInputs } from "../Inscription/checkInputs"

const Connexion = (): JSX.Element => {
    return (
        <div id="connexion">
            <div id="content">
                <div id="main">
                    <h1>Connexion</h1>
                    <div id="identifiants">
                        <input type="mail" name="connexion" placeholder="email address" />
                        <input type="password" name="mot_de_passe" placeholder="Password"/>
                    </div>
                    <div id="checkbox">
                        <input type="checkbox" name="rester_connecter" id="rester_connecter" />
                        <label htmlFor="rester_connecter">stay logged in</label>
                    </div>
                    <button onClick={ () => {
                        if (checkInputs())
                            window.location.href = "/compte"
                    }}>Se connecter</button>
                </div>
                <div id="inscription">
                    <h3>1st time ?</h3>
                    <button onClick={ () => window.location.href="/inscription"} >Sign in</button>
                </div>
            </div>
        </div>
    )
}

export default Connexion